import { Badge, keyframes } from "@mui/material";
import { AttachMoney as AttachMoneyIcon } from "@mui/icons-material";
import { useStakeholderPayments } from "hooks/stakeholder/useStakeholderPayments";


const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

export default function StakeholderInvoiceCount() {
  const { clientInvoices } = useStakeholderPayments();
  const unpaidInvoicesCount = clientInvoices?.filter(invoice => invoice.status === "unpaid").length || 0;

  return (
    <Badge
      color="error"
      badgeContent={unpaidInvoicesCount}
      invisible={unpaidInvoicesCount === 0}
      sx={{
        "& .MuiBadge-badge": { right: -5 },
      }}
    >
      <AttachMoneyIcon />
    </Badge>
  );
};
